<button
    class="visibly-hidden-focusable button inline-block"
    [routerLink]="[]"
    [fragment]="'main'"
    (click)="focusOnMain()"
>
    Zum Inhalt springen
</button>
<app-header (mainMenuToggle)="handleMainMenuToggle($event)"></app-header>
<main
    id="main"
    class="outlet-wrapper"
    [inert]="isMainMenuOpen()"
>
    <router-outlet> </router-outlet>
</main>
<app-action-buttons [inert]="isMainMenuOpen()"></app-action-buttons>
<app-spinner></app-spinner>
<app-notification
    [notificationCount]="3"
    [closeAfter]="-1"
></app-notification>
<app-footer [inert]="isMainMenuOpen()"></app-footer>
<button
    aria-label="Nach oben"
    type="button"
    class="button to-top-button"
    (click)="up()"
    ctrlTooltip
    [ctrlTooltipConfig]="{ position: 'left-center', offsetY: 0, offsetX: 16 }"
    [inert]="isMainMenuOpen()"
>
    <ctrl-tooltip class="-left">Nach oben</ctrl-tooltip>
</button>
